import { NotificationTypeEnum } from './../enums/notificationtypeenum';

export class NotificationTypeHelper {

    typeNames = new Map();

    constructor() {
        this.typeNames.set(NotificationTypeEnum.Recordables, "Recordables");
        this.typeNames.set(NotificationTypeEnum.ChangeOrder, "Change Orders");
    }
}